import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Observer} from "gsap/Observer";

gsap.registerPlugin(ScrollTrigger, Observer);

export const FactSlider = () => {
    const header = document.getElementById('header');
    const backup = document.querySelector('.facts__backup');
    const factsContainer = document.querySelector('.facts__timeline');
    if(!factsContainer) return;

    let slidesPadding = factsContainer.querySelectorAll('.facts__slides .factslide--padding');
    let factscontent = document.getElementsByClassName('row--factscontent')[0];
    let factscontentHeight = factscontent.offsetHeight;
    let slideHeight = getLargestFactSlideHeight();
    let headerHeight = header.offsetHeight;

    backupSlides();
    setLargestFactSlideHeight();

    let tl = initTimeLine(headerHeight);

    function restoreSlides(){
        factsContainer.innerHTML = backup.innerHTML;
    }

    function backupSlides() {
        backup.innerHTML = factsContainer.innerHTML;
    }

    function handleResize() {
        setLargestFactSlideHeight(true);
    }

    function debounce(func, timeout = 300) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    function getStartPosition() {
        factscontent = document.getElementsByClassName('row--factscontent')[0];
        factscontentHeight = factscontent.offsetHeight;
        let margin = 75;
        let slidesHeight = getLargestFactSlideHeight();
        headerHeight = header.offsetHeight;
        let windowHeight = window.outerHeight;
        let startTrigger = '.facts__timeline .facts__container';

        if(windowHeight <  slidesHeight + margin + factscontentHeight + headerHeight ) {
            startTrigger = '.facts__timeline .facts__slides';
        }
        return startTrigger;
    }

    function initTimeLine(headerHeight) {
        return gsap.timeline({
            scrollTrigger: {
                trigger: getStartPosition(),
                pin: true,
                start: 'top ' + headerHeight + 'px',
                end: '+=300%',
                scrub: 6,
                ease: 'linear',
                markers: false,
                preventOverlaps: true,
                fastScrollEnd: 10000
            }
        });
    }

    slidesPadding.forEach(slide => {
        slide.style.marginTop = '1000px';
        slide.style.transform = 'scale(1.5)';
    });

    const slides = document.querySelectorAll('.facts__timeline .factslide');
    slides.forEach((slide, index) => {
        tl.to(slide, {
            marginBottom: -slideHeight,
            marginTop: 0,
            opacity: 1,
            scale: 1,
            duration: 2
        }, index === 0 ? '>' : '>');
    });

    tl.to({}, {
        duration: 2 // Dauer der Pause in Sekunden
    });

    function getLargestFactSlideHeight() {
        const slides = document.querySelectorAll('.facts__timeline .facts__slides .factslide');
        let maxHeight = 0;
        slides.forEach(slide => {
            const height = slide.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        return maxHeight;
    }

    function unsetFactSlideHeight() {
        const slides = document.querySelectorAll('.facts__timeline .facts__slides .factslide');
        slides.forEach(slide => {
            slide.style.height = 'auto';
            slide.querySelector('.factslide__content').style.height = 'auto';
        });
        const slidesContainers = document.querySelectorAll('.facts__timeline .facts__slides');
        slidesContainers.forEach(slidesContainer => {
            slidesContainer.style.height = 'auto';
        });
    }

    function setLargestFactSlideHeight(reinit = false) {
        if (reinit) {
            tl.clear();
            tl.kill();
            restoreSlides();
        }

        let slides = factsContainer.querySelectorAll('.facts__slides .factslide');
        let maxHeight = 0;
        let maxHeightContent = 0;
        slides.forEach(slide => {
            let height = slide.offsetHeight;
            let heightContent = slide.querySelector('.factslide__content').offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
            if (heightContent > maxHeightContent) {
                maxHeightContent = heightContent;
            }
        });

        slides.forEach(slide => {
            slide.style.height = maxHeight + 'px';
            slide.querySelector('.factslide__content').style.height = maxHeightContent + 'px';
        });

        const slidesContainers = factsContainer.querySelectorAll('.facts__slides');
        slidesContainers.forEach(slidesContainer => {
            slidesContainer.style.height = maxHeight + 'px';
        });

        if (reinit) {
            headerHeight = header.offsetHeight;
            tl = initTimeLine(headerHeight);
            slidesPadding = factsContainer.querySelectorAll('.facts__slides .factslide--padding');
            slideHeight = getLargestFactSlideHeight();
            slidesPadding.forEach(slide => {
                slide.style.marginTop = '1000px';
                slide.style.transform = 'scale(1.5)';
            });

            const slides = document.querySelectorAll('.facts__timeline .factslide');
            slides.forEach((slide, index) => {
                tl.to(slide, {
                    marginBottom: -slideHeight,
                    marginTop: 0,
                    opacity: 1,
                    scale: 1,
                    duration: 2
                }, index === 0 ? '>' : '>');
            });
            tl.to({}, {
                duration: 2
            });
        }
    }

    window.addEventListener('resize', debounce(handleResize));
}
